import React from 'react';
import clsx from 'clsx';
import Image, { ImageLoaderProps } from 'next/image';
import { ImageProps, RenditionProps } from './MerchImage.types';
import Head from 'next/head';

const customLoader = ({ src }: ImageLoaderProps): string => {
  return src;
};

export const MerchImage = (props: ImageProps) => {
  const { title, defaultImageURL, customClass, renditions, altText = 'Card Overview Image', loading = 'lazy' } = props;

  return (
    <>
      {defaultImageURL && (
        <Head>
          <link rel="preload" as="image" href={defaultImageURL} />
        </Head>
      )}
      <picture data-component-name="m-merchandising-image" data-testid="merchandising-image">
        {renditions?.map((rendition: RenditionProps, index: number) => {
          const { renditionPath, mediaValue, mediaQuery } = rendition;
          const media = `(${mediaQuery}: ${mediaValue})`;
          return renditionPath?.length ? (
            <source key={index} media={media} srcSet={renditionPath} data-testid={'source-img-' + index} />
          ) : (
            ''
          );
        })}

        {defaultImageURL && (
          <Image
            loader={customLoader}
            src={defaultImageURL}
            className={clsx('image', loading, customClass)}
            alt={altText}
            title={title}
            data-src={defaultImageURL}
            loading={loading}
          />
        )}
      </picture>
    </>
  );
};
